import { UserThemeRepository } from '../../domain/repository/user_theme_repository';
import { UserThemeApiService } from '../data_source/user_theme_api_service';
import { StartThemeInterface } from '../../domain/interface/start_theme_interface';
import { FinishThemeInterface } from '../../domain/interface/finish_theme_interface';
import { UserThemeInterface } from '../../domain/interface/user_theme_interface';

export class UserThemeRepositoryImpl implements UserThemeRepository {
  private readonly userThemeApiService: UserThemeApiService;

  constructor() {
    this.userThemeApiService = new UserThemeApiService();
  }

  async startTheme(data: StartThemeInterface): Promise<UserThemeInterface> {
    const response = await this.userThemeApiService.startTheme(data);
    return response.data;
  }

  async finishTheme(data: FinishThemeInterface): Promise<UserThemeInterface> {
    const response = await this.userThemeApiService.finishTheme(data);
    return response.data;
  }

  async deleteUserThemeInProgress(): Promise<boolean> {
    const response =
      await this.userThemeApiService.deleteUserThemeInProgress();
    if (response.status === 204) return true;
    return false;
  }
}
